import { Container, Header, SpaceBetween } from "@amzn/awsui-components-react";
import { getString } from "common/ui_string_labels/ui-strings-utils";
import { JSX, ReactNode } from "react";


/**
 * Represents the props for the FilterSection component.
 * @interface
 * @property {ReactNode} children - The content of the filter section
 */
export interface FilterSectionProps {
    children?: ReactNode;
}

/**
 * Renders a wrapper for the filter sections
 *
 * @param {ReactNode} children - The components to be rendered inside the wrapper
 * @returns {JSX.Element} - The rendered content layout
 */
export default function FilterSection({ children }: FilterSectionProps): JSX.Element {
    return (
        <Container header={<Header variant="h2">{getString("common.component.FilterSection.title")}</Header>}>
            <SpaceBetween size="m">{children}</SpaceBetween>
        </Container>
    );
}
